<div class="section">
  <header>
    <h1>403 - Forbidden</h1>
  </header>

  <main>
    <p class="error-message">Nie masz uprawnień by przeglądać tą stronę.</p>
    <a href="#" class="home-link" (click)="navigateToHome($event)">Wróć do strony głównej</a>
  </main>
</div>